module.exports = __webpack_public_path__ + "static/img/3.cb49f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/3.png
// module id = 6PZE
// module chunks = 0